import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "spinner" }, null, -1)

import { ethers } from 'ethers';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import apiHelpers from '@/api/apiHelpers';
import { ClaimConfig } from '@/api/models/claim';
import { NETWORK_ID } from '@/common/constants';
import ClaimCompleteBody from '@/components/ClaimCompleteBody.vue';
import NotFound from '@/components/NotFound.vue';
import TermAndService from '@/components/TermAndService.vue';
import { AuthState } from '@/store/modules/account.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MClaimComplete',
  props: ['id', 'claimConfig'],
  setup(__props) {

const props = __props;


const store = useStore();
// claim object need to be adjusted before passing into ClaimCompleteBody (Ex: use correct fallbackProvider)
const claimConfig = ref();
const isLoading = ref(false);
const isTermsOfUse = ref(false);

const setAuthState = (authState: AuthState) => store.dispatch('Account/setAuthState', authState);
const detectProvider = () => store.dispatch('Account/detectProvider');
const detectChainChanged = () => store.dispatch('Account/detectChainChanged');
const detectProviderChanged = () => store.dispatch('Account/detectProviderChanged');
const setNetwork = (network: string) => store.dispatch('Account/setNetwork', network);

const validateFallbackProvider = async (fallbackProvider: string) => {
  const provider = new ethers.providers.WebSocketProvider(fallbackProvider);
  const timeOut = new Promise<Response>((resolve, reject) =>
    setTimeout(() => reject(new Error('timeout')), 2000)
  );
  // provider.ready check if connection to provider is valid, timeout after 2s
  await Promise.race([provider.ready, timeOut]);
};

const initializeClaimCorrected = async () => {
  let claim;
  if (props.id) {
    claim = ClaimConfig.fromJson(await apiHelpers.fetch(`/public/instance/data?id=${props.id}`));
  } else {
    // attempt to get id from url
    try {
      const url = window?.location?.href;
      const splitByQUery = url.split('?');
      const urlSplits = splitByQUery[0].split('/');
      const appSlug = urlSplits[urlSplits.length - 2];
      const instanceSlug = urlSplits[urlSplits.length - 1];
      // for terms and services page
      if (instanceSlug === 'terms-of-use' && urlSplits.length === 4) {
        isTermsOfUse.value = true;
        throw new Error('Terms of use');
      }
      if (!appSlug || !instanceSlug) return;
      const path = `https://apps.api.manifoldxyz.dev/public/instance/data?instanceSlug=${instanceSlug}&appId=2538262199`;
      const claimConfigData = await fetch(path);
      const claimConfigJson = await claimConfigData.json();
      claim = ClaimConfig.fromJson(await apiHelpers.fetch(`/public/instance/data?id=${claimConfigJson.id}`));
      document.title = claimConfigJson.publicData.name;
    } catch (e) {
      console.error(e);
    }
  }

  // Check if creator provide their own node, and check if the node is valid, use our node otherwise
  if (claim?.fallbackProvider?.length) {
    try {
      await validateFallbackProvider(claim.fallbackProvider);
    } catch (e) {
      // Do not use our provider if the creator provider is not valid, we will use provider from wallet connect for write operations, and our own node for read operations
      claim.fallbackProvider = undefined;
    }
  }

  claimConfig.value = claim;
  if (!claimConfig.value?.fallbackProvider) {
    claimConfig.value.fallbackProvider = 'wss://eth-mainnet.g.alchemy.com/v2/ZXKXZ83la90MCsLU4b5qYSHwH9Nhw4dE';
  }
};

// const getDominantColor = async (url: string) : Promise<void> => {
//   let optimizedUrl = url;
//   if (url.includes('assets.manifold.xyz') || url.includes('q_80,w_1024')) {
//     optimizedUrl = url.replace('q_80,w_1024', 'q_30,w_800');
//   }

//   // Set up the request parameters for the Vision API
//   const request = {
//     requests: [
//       {
//         image: {
//           source: {
//             imageUri: `${optimizedUrl}`
//           }
//         },
//         features: [
//           {
//             maxResults: 1,
//             type: 'IMAGE_PROPERTIES'
//           }
//         ]
//       }
//     ]
//   };

//   const res = await fetch('https://vision.googleapis.com/v1/images:annotate?key=AIzaSyAo3SKlpEBxTpc6iUbrKd8tdo7n9CEgSMA', {
//     method: 'POST',
//     body: JSON.stringify(request),
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   });
//   const data = await res.json();
//   const imageProperties = data.responses[0].imagePropertiesAnnotation;
//   const dominantColor = imageProperties.dominantColors.colors[0];
//   dominantBackgroundColor.value = `rgb(${dominantColor.color.red},${dominantColor.color.green},${dominantColor.color.blue})`;
// };

onMounted(async () => {
  isLoading.value = true;
  try {
    await initializeClaimCorrected();

    setAuthState(AuthState.UNKNOWN);
    window.addEventListener('ethereum-address-changed', () => {
      detectProvider();

      if ((window as any).ManifoldEthereumProvider.selectedAddress()) {
        store.dispatch('Account/setAuthState', AuthState.LOGGED_IN);
      } else {
        store.dispatch('Account/setAuthState', AuthState.GUEST);
      }
    });
    window.addEventListener('frontend-provider-chain-changed', detectChainChanged);
    window.addEventListener('frontend-provider-chain-changed', detectProviderChanged);

    await (window as any).ManifoldEthereumProvider.initialize({ network: NETWORK_ID, fallbackHost: claimConfig?.value?.fallbackProvider?.length ? claimConfig?.value?.fallbackProvider : undefined });

    if (!(window as any).ManifoldEthereumProvider.chainIsCorrect()) {
      setNetwork('unknown');
    }

    // // grab background color
    // if (claimConfig?.value?.image) {
    //   try {
    //     await getDominantColor(claimConfig?.value?.image);
    //   } catch (e) {
    //     console.error(`Unable to grab image from google vision ${e}`);
    //   }
    // }
  } catch (e: any) {
    isLoading.value = false;
    if (e?.message === 'Terms of use') {
      return;
    }
    throw e;
  }
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (claimConfig.value && !isLoading.value && !isTermsOfUse.value)
    ? (_openBlock(), _createBlock(ClaimCompleteBody, {
        key: 0,
        claimConfig: claimConfig.value
      }, null, 8, ["claimConfig"]))
    : (isLoading.value)
      ? (_openBlock(), _createBlock(_Transition, {
          key: 1,
          id: "claim-complete-loading",
          name: "fade"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : (isTermsOfUse.value)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 2,
            id: "claim-complete-terms-of-use",
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(TermAndService)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(NotFound, { key: 3 }))
}
}

})